import Vue from "vue";
import Vuex from "vuex";

const Perimeter = {
    namespaced: true,
    state: {
        perimeters: [],
        perimeterSelected : {}
    },
    actions : {


        deletePerimeter(context, id){
            Vue.axios.delete(window.urlapi + "perimeter/"+id).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        
                        context.commit("DELETEPERIMETERSOPERATOR", id);
                    }
                },
            );
        },
        addPerimeter(context,zone){
            Vue.axios.post(window.urlapi + "perimeter",zone).then(
                response => {
                    if (response.data.success == true) {
                        Vue.prototype.$awn.success(
                            response.data.message.toString()
                        );
                        zone.id = response.data.data
                        context.commit("ADDPERIMETERSOPERATOR", zone);
                    }
                },
            );
        },

        getPerimeters(context,search){
            let strSearch = "?";
            if(search.type){
                strSearch += "type="+search.type
            }
            if(search.lon && search.lat){
                strSearch += (strSearch != "?") ? "&" : ""
                strSearch += "lon="+search.lon+"&lat="+search.lat
            }
            return new Promise((resolve, reject) => {
                Vue.axios.get(window.urlapi + "perimeter"+strSearch).then(
                    response => {
                        resolve(response.data.data);
                        context.commit("GETPERIMETERS", response.data.data)
                    },
                );
            })
        },
        getPerimeter(context,id){
             Vue.axios.get(window.urlapi + "perimeter/"+id).then(
                 response => {
                     context.commit("GETPERIMETER", response.data.data);
                 },
             );
        }
    },
    mutations: {

        DELETEPERIMETERSOPERATOR: (state, id) => {
            let toDelete = state.perimeters.findIndex(item => item.id === id);
            state.perimeters.splice(toDelete,1);
        },
        GETPERIMETERS: (state, perimeters) => {
            state.perimeters = perimeters;
        },
    
        ADDPERIMETERSOPERATOR: (state, perimeter) => {
            state.perimeters.push(perimeter);
        },
        GETPERIMETER: (state, perimeter) => {
            state.perimeterSelected = perimeter;
        }
    },
    getters: {
        perimeters: state => {
            return state.perimeters;
        },
        perimeterById: state => id => {
            let result = state.perimeters.find(item => item.id === id);
            return result;
        },
        countPerimeters: state => {
            return state.perimeters.length;
        },
        perimeterSelected : state => {
            return state.perimeterSelected;
        }
    },
    modules: {}
};

export default Perimeter;
